<template>
  <section class="pb-4">
    <h3 class="text-h2 mb-8">{{ sectionData.name }}</h3>
    <AreaHelpContactUsFaqCardRow
      v-for="(item, index) in sectionData.subSections"
      :key="hash(item)"
      :section-data="item"
      :is-first="index === 0"
    />
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection;
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });
</script>
